// extracted by mini-css-extract-plugin
module.exports = {"mainComponent":"style_mainComponent__102Y8","mainContent":"style_mainContent__jDRTE","rightContainer":"style_rightContainer__3w2aE"};